import { render } from "./ShowProductsOutStock.vue?vue&type=template&id=17e5af5a"
import script from "./ShowProductsOutStock.vue?vue&type=script&lang=js"
export * from "./ShowProductsOutStock.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__